import { getJson, postJson, withOptional, withValidate, withDone } from '@rad/utility/http';
export const MANUALLY_ENTERED_CATEGORY = 'Manually Entered';
export const getMeasures = () => getJson('/api/measures');
export const getMeasuresAll = () => getJson('/api/measures/all');
export const getMeasure = (id) => withOptional(getJson(`/api/measures/${id}`));
export const getMeasureCategories = () => getJson('/api/measures/categories');
export const requestMeasure = () => postJson('/api/measures/request');
export const cloneMeasure = (x) => withDone(withValidate(postJson(`/api/measures/${x.id}/clone`, x)))();
export const createMeasure = (x) => withDone(withValidate(postJson(`/api/measures`, x)))();
export const updateMeasure = (x) => withDone(withValidate(postJson(`/api/measures/${x.id}`, x)))();
